var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import Paper from '../Paper';
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        wrapper: {
            paddingTop: '0.7rem',
            overflow: 'auto',
            position: 'relative',
            zIndex: theme.zIndex.appBar - 1,
        },
        padLeft: (_a = {
                paddingLeft: theme.spacing(2)
            },
            _a[theme.breakpoints.up('sm')] = {
                paddingLeft: theme.spacing(3),
            },
            _a),
        padBottom: {
            paddingBottom: '0.7rem',
        },
    });
});
var BreadcrumbsWrapper = function (_a) {
    var children = _a.children, _b = _a.padLeft, padLeft = _b === void 0 ? true : _b, _c = _a.padBottom, padBottom = _c === void 0 ? true : _c, rest = __rest(_a, ["children", "padLeft", "padBottom"]);
    var classes = useStyles();
    return (React.createElement(Paper, __assign({ className: cx(classes.wrapper, padLeft && classes.padLeft, padBottom && classes.padBottom), elevation: 3, square: true }, rest), children));
};
export default BreadcrumbsWrapper;
//# sourceMappingURL=BreadcrumbsWrapper.js.map